<template>
  <div class="text-start">
    <v-row
      v-for="(trainingModule, trainingModuleIndex) in trainingModules"
      :key="`trainingModule_${trainingModuleIndex}`"
      no-gutters
      class="mb-10"
    >
      <v-col>
        <CourseModule
          :training="training"
          @update:training="
            updatedTraining => $emit('update:training', updatedTraining)
          "
          :selectedTrainingModule="{ trainingModuleIndex }"
          :isEditing="isEditing"
          :selectedLocale="selectedLocale"
          @onTrainingModuleContentSelection="
            trainingModuleContentIndex =>
              onTrainingModuleContentSelection({
                trainingModuleIndex,
                trainingModuleContentIndex,
              })
          "
          @onSuccess="$emit('onSuccess')"
          @onError="$emit('onError')"
        />
      </v-col>
    </v-row>

    <!--training module add button-->
    <v-row v-if="isEditing" no-gutters class="mt-12">
      <v-col>
        <v-btn
          depressed
          block
          color="textLight"
          class="
            subtitle-1
            font-weight-regular
            white--text
            text-capitalize
            rounded-lg
          "
          @click="addTrainingModule"
        >
          <v-icon left size="20">mdi-plus</v-icon>

          {{ $t("course.courseDetails.addNewModule") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CourseModule from "@/app/course-module/components/course-details/CourseModule";

export default {
  name: "CourseSyllabus",
  components: { CourseModule },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  computed: {
    trainingModules() {
      return this.training.trainingModules ?? [];
    },
  },
  methods: {
    emitUpdateTraining() {
      this.$emit("update:training", {
        ...this.training,
        trainingModules: this.trainingModules,
      });
    },
    addTrainingModule() {
      this.trainingModules.push({
        training: {
          _id: this.training._id,
        },
        hasChangesInTitle: true,
        hasInvalidTitle: true,
      });

      this.onTrainingModuleContentSelection({});

      this.emitUpdateTraining();
    },
    onTrainingModuleContentSelection({
      trainingModuleIndex,
      trainingModuleContentIndex,
    }) {
      if (trainingModuleIndex >= 0 && trainingModuleContentIndex >= 0) {
        this.$emit("onTrainingModuleContentSelection", {
          trainingModuleIndex,
          trainingModuleContentIndex,
        });
      } else {
        this.$emit("onTrainingModuleContentSelection");
      }
    },
  },
};
</script>

<style lang="scss" scoped />
